// import React, { useState } from 'react';
// import { DollarSign, Zap, Users, TrendingUp, Wrench, FileText, BarChart2, Package, Clock, Eye, ChevronRight, Filter, Search, Calendar, Settings, Loader } from 'lucide-react';
// import { useGetAnnualIncomeReportQuery, useGetAnnualOccupancyReportQuery,useGetAnnualExpenseReportQuery,useGetAnnualRepairsReportQuery } from '../../../app/lib/apiSlice/reportsSlice/reportSlice.tsx';



// const useGetReportQuery = (reportType, month, year) => {
//   const { data: rentincomeReport, incomeLoading, icomcError } = useGetAnnualIncomeReportQuery({ year: year })
//   const { data: occupancyReport, incomeLoading, icomcError } = useGetAnnualOccupancyReportQuery({ year: year })
//   const { data: utilityncomeReport, incomeLoading, icomcError } = useGetAnnualExpenseReportQuery({ year: year })
//   const { data: repairsReport, incomeLoading, icomcError } = useGetAnnualRepairsReportQuery({ year: year })

//   const isLoading = false; // Mock loading state
//   const data = {}; // Mock data

//   // Simulate different endpoints based on report type
//   const endpoints = {
//     'rent-income': rentincomeReport,
//     'tenant-analytics': occupancyReport,
//     'property-valuation': '',
//     'maintenance-dashboard': '',
//     'utilities-report': utilityncomeReport,
//     'expense-analysis': repairsReport,
//     'financial-performance': '',
//     'vendor-management': ''
//   };

//   return {
//     data,
//     isLoading,
//     endpoint: endpoints[reportType] || '/api/reports/default'
//   };
// };

// const useDownloadReportMutation = () => {
//   // This would be your actual RTK mutation hook in a real implementation
//   const [isLoading, setIsLoading] = useState(false);

//   const trigger = async (reportType, month, year) => {
//     setIsLoading(true);
//     // Simulate API call
//     await new Promise(resolve => setTimeout(resolve, 1000));
//     setIsLoading(false);
//     return { data: { url: `/download/${reportType}-${month}-${year}.pdf` } };
//   };

//   return [trigger, { isLoading }];
// };

// const ReportCard = ({
//   title,
//   description,
//   updatedTime,
//   lastViewed,
//   icon,
//   iconColor,
//   views,
//   isNew,
//   reportStatus,
//   reportType
// }) => {
//   const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
//   const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
//   const [showDatePicker, setShowDatePicker] = useState(false);

//   const { data, isLoading, endpoint } = useGetReportQuery(reportType, selectedMonth, selectedYear);
//   const [downloadReport, { isLoading: isDownloading }] = useDownloadReportMutation();

//   const handleGetReport = () => {
//     setShowDatePicker(!showDatePicker);
//   };

//   const handleDownload = async () => {
//     try {
//       const result = await downloadReport(reportType, selectedMonth, selectedYear);
//       // In a real app, you would handle the download URL
//       console.log('Download URL:', result.data.url);
//       // For demo purposes, we'll just show an alert
//       alert(`Downloading ${title} for ${selectedMonth}/${selectedYear}`);
//     } catch (error) {
//       console.error('Download failed:', error);
//     }
//   };

//   // Extract the color from the iconColor prop to use for buttons
//   const colorClass = iconColor.match(/bg-(.+)-[0-9]+/)[1];
//   const buttonColor = `bg-${colorClass}-600 hover:bg-${colorClass}-700`;

//   return (
//     <div className="group bg-white hover:shadow-lg border border-gray-50 rounded-2xl overflow-hidden transition-all duration-300">
//       <div className="p-6">
//         <div className="flex items-start gap-4">
//           {/* Icon container */}
//           <div className={`p-2.5 rounded-lg ${iconColor} bg-opacity-15 flex-shrink-0`}>
//             {React.cloneElement(icon, {
//               className: `${icon.props.className} group-hover:scale-105 transition-transform w-4 h-4`
//             })}
//           </div>

//           {/* Text content */}
//           <div className="flex-1 space-y-3 min-w-0">
//             {/* Title row */}
//             <div className="flex justify-between items-start">
//               <div className="flex items-center gap-2">
//                 <h3 className="font-semibold text-gray-800 text-lg leading-tight">
//                   {title}
//                 </h3>
//               </div>
//             </div>

//             {/* Description */}
//             <p className="text-gray-500 text-sm line-clamp-2 leading-relaxed">
//               {description}
//             </p>

//             {/* Footer with view stats */}
//             <div className="flex justify-between items-center pt-2">
//               <div className="flex items-center text-gray-400 text-xs">
//                 {reportStatus && (
//                   <span className='text-uppercase'>{reportStatus}</span>
//                 )}
//               </div>

//               {reportStatus ? "" : (
//                 <div className="relative">
//                   <button
//                     onClick={handleGetReport}
//                     className={`text-white px-3 py-1 rounded-lg text-sm font-medium ${buttonColor} transition-colors flex items-center gap-1`}
//                     disabled={isLoading || isDownloading}
//                   >
//                     {(isLoading || isDownloading) ? (
//                       <Loader className="w-4 h-4 animate-spin" />
//                     ) : (
//                       'Get Report'
//                     )}
//                   </button>

//                   {showDatePicker && (
//                     <div className="right-0 bottom-full z-10 absolute bg-white shadow-lg mb-2 p-3 border border-gray-200 rounded-lg w-64">
//                       <div className="mb-2">
//                         <label className="block mb-1 font-medium text-gray-700 text-sm">Month</label>
//                         <select
//                           value={selectedMonth}
//                           onChange={(e) => setSelectedMonth(e.target.value)}
//                           className="p-2 border border-gray-300 rounded w-full"
//                         >
//                           {Array.from({ length: 12 }, (_, i) => i + 1).map(month => (
//                             <option key={month} value={month}>{month}</option>
//                           ))}
//                         </select>
//                       </div>
//                       <div className="mb-3">
//                         <label className="block mb-1 font-medium text-gray-700 text-sm">Year</label>
//                         <select
//                           value={selectedYear}
//                           onChange={(e) => setSelectedYear(e.target.value)}
//                           className="p-2 border border-gray-300 rounded w-full"
//                         >
//                           {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i).map(year => (
//                             <option key={year} value={year}>{year}</option>
//                           ))}
//                         </select>
//                       </div>
//                       <div className="flex gap-2">
//                         <button
//                           onClick={handleDownload}
//                           className={`flex-1 text-white px-3 py-1 rounded-lg text-sm font-medium ${buttonColor} transition-colors flex items-center justify-center gap-1`}
//                           disabled={isDownloading}
//                         >
//                           {isDownloading ? (
//                             <Loader className="w-4 h-4 animate-spin" />
//                           ) : (
//                             'Download'
//                           )}
//                         </button>
//                         <button
//                           onClick={() => setShowDatePicker(false)}
//                           className="flex-1 bg-gray-200 hover:bg-gray-300 px-3 py-1 rounded-lg font-medium text-gray-700 text-sm transition-colors"
//                         >
//                           Cancel
//                         </button>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const AvailableReports = () => {
//   const [activeFilter, setActiveFilter] = useState('all');

//   const allReports = [
//     {
//       id: 1,
//       title: "Rent Income Collection Report",
//       description: "Detailed breakdown of rent payments, delinquencies, and collection rates across all properties.",
//       updatedTime: "Updated 2 hours ago",
//       lastViewed: "today",
//       views: "",
//       isNew: true,
//       category: "financial",
//       icon: <DollarSign className="w-5 h-5 text-purple-600" />,
//       iconColor: "bg-purple-100",
//       reportType: "rent-income"
//     },
//     {
//       id: 2,
//       title: "Tenant Analytics",
//       description: "Comprehensive tenant profiles, lease expirations, and satisfaction metrics.",
//       updatedTime: "Updated yesterday",
//       lastViewed: "2 days ago",
//       views: "18",
//       isNew: false,
//       category: "tenant",
//       icon: <Users className="w-5 h-5 text-blue-600" />,
//       iconColor: "bg-blue-100",
//       reportType: "tenant-analytics"
//     },
//     {
//       id: 3,
//       title: "Property Valuation",
//       description: "Current market values, appreciation trends, and comparative analysis for your portfolio.",
//       updatedTime: "Updated 1 day ago",
//       lastViewed: "yesterday",
//       views: "32",
//       isNew: false,
//       category: "financial",
//       icon: <TrendingUp className="w-5 h-5 text-green-600" />,
//       iconColor: "bg-green-100",
//       reportStatus: "Coming Soon",
//       reportType: "property-valuation"
//     },
//     {
//       id: 4,
//       title: "Maintenance Dashboard",
//       description: "Open work orders, maintenance costs, and vendor performance metrics.",
//       updatedTime: "Updated 5 hours ago",
//       lastViewed: "today",
//       views: "15",
//       isNew: false,
//       category: "maintenance",
//       icon: <Wrench className="w-5 h-5 text-yellow-600" />,
//       iconColor: "bg-yellow-100",
//       reportType: "maintenance-dashboard"
//     },
//     {
//       id: 5,
//       title: "Utilities Report",
//       description: "Utility costs, consumption trends, and financial performance across all properties.",
//       updatedTime: "Updated 3 hours ago",
//       lastViewed: "Today",
//       views: "21",
//       isNew: true,
//       category: "financial",
//       icon: <Zap className="w-5 h-5 text-pink-600" />,
//       iconColor: "bg-pink-100",
//       reportType: "utilities-report"
//     },
//     {
//       id: 6,
//       title: "Expense Analysis",
//       description: "Operating expenses, capital expenditures, and budget variance reporting.",
//       updatedTime: "Updated 4 hours ago",
//       lastViewed: "1 hour ago",
//       views: "12",
//       isNew: false,
//       category: "financial",
//       icon: <FileText className="w-5 h-5 text-yellow-800" />,
//       iconColor: "bg-yellow-200",
//       reportStatus: "Coming Soon",
//       reportType: "expense-analysis"
//     },
//     {
//       id: 7,
//       title: "Financial Performance",
//       description: "NOI calculations, cash flow statements, and ROI metrics for your portfolio.",
//       updatedTime: "Updated 6 hours ago",
//       lastViewed: "today",
//       views: "28",
//       isNew: false,
//       category: "financial",
//       icon: <BarChart2 className="w-5 h-5 text-gray-600" />,
//       iconColor: "bg-gray-300",
//       reportStatus: "Coming Soon",
//       reportType: "financial-performance"
//     },
//     {
//       id: 8,
//       title: "Vendor Management",
//       description: "Contractor performance, service level agreements, and payment histories.",
//       updatedTime: "Updated 1 week ago",
//       lastViewed: "3 days ago",
//       views: "9",
//       isNew: false,
//       category: "operational",
//       icon: <Package className="w-5 h-5 text-red-600" />,
//       iconColor: "bg-red-100",
//       reportStatus: "Coming Soon",
//       reportType: "vendor-management"
//     }
//   ];

//   const filteredReports = activeFilter === 'all'
//     ? allReports
//     : allReports.filter(report => report.category === activeFilter);

//   const filterButtons = [
//     { id: 'all', label: 'All Reports' },
//     { id: 'financial', label: 'Financial' },
//     { id: 'operational', label: 'Operational' },
//     { id: 'tenant', label: 'Tenant' },
//     { id: 'maintenance', label: 'Maintenance' },
//   ];

//   return (
//     <div className="bg-white shadow-lg p-6 rounded-xl">
//       <div className="flex md:flex-row flex-col justify-between items-start md:items-center gap-4 mb-8">
//         <div>
//           <h1 className="font-bold text-gray-900 text-2xl md:text-3xl">Property Reports</h1>
//         </div>

//         <div className="flex sm:flex-row flex-col gap-3 w-full md:w-auto">
//           <div className="relative flex-1 max-w-md">
//             <Search className="top-1/2 left-3 absolute w-4 h-4 text-gray-400 -translate-y-1/2 transform" />
//             <input
//               type="text"
//               placeholder="Search reports..."
//               className="bg-white py-2.5 pr-4 pl-10 border border-gray-200 focus:border-blue-500 rounded-xl focus:ring-blue-500 w-full text-sm"
//             />
//           </div>
//         </div>
//       </div>

//       <div className="flex flex-wrap gap-3 mb-6">
//         {filterButtons.map((button) => (
//           <button
//             key={button.id}
//             onClick={() => setActiveFilter(button.id)}
//             className={`px-4 py-2 rounded-xl text-sm font-medium flex items-center transition-colors ${activeFilter === button.id
//               ? 'bg-indigo-600 text-white shadow-md'
//               : 'bg-white hover:bg-gray-50 border border-gray-200 text-gray-600'
//               }`}
//           >
//             {button.icon || null}
//             {button.label}
//           </button>
//         ))}
//       </div>

//       <div className="gap-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
//         {filteredReports.map((report) => (
//           <ReportCard
//             key={report.id}
//             title={report.title}
//             description={report.description}
//             updatedTime={report.updatedTime}
//             lastViewed={report.lastViewed}
//             views={report.views}
//             isNew={report.isNew}
//             icon={report.icon}
//             iconColor={report.iconColor}
//             reportStatus={report.reportStatus}
//             reportType={report.reportType}
//           />
//         ))}
//       </div>

//       {filteredReports.length === 0 && (
//         <>
//           <div className="py-12 text-center">
//             <div className="flex justify-center items-center bg-gray-100 mx-auto mb-4 rounded-full w-24 h-24">
//               <FileText className="w-10 h-10 text-gray-400" />
//             </div>
//             <h3 className="mb-1 font-medium text-gray-900 text-lg">No reports found</h3>
//             <p className="text-gray-500">Try adjusting your filters or search criteria</p>
//           </div>

//           <div className="flex justify-center mt-8">
//             <button className="flex items-center gap-2 bg-white hover:bg-gray-50 px-5 py-2.5 border border-gray-200 rounded-xl font-medium text-gray-600 text-sm">
//               Load More Reports
//               <ChevronRight className="w-4 h-4" />
//             </button>
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default AvailableReports;

























import React, { useState } from 'react';
import { DollarSign, Zap, Users, TrendingUp, Wrench, FileText, BarChart2, Package, Loader,ChevronRight,Search } from 'lucide-react';
import { toast } from 'react-toastify';
import {
  useLazyGetAnnualIncomeReportQuery,
  useLazyGetAnnualOccupancyReportQuery,
  useLazyGetAnnualExpenseReportQuery,
  useLazyGetAnnualRepairsReportQuery
} from '../../../app/lib/apiSlice/reportsSlice/reportSlice.tsx';

const ReportCard = ({
  title,
  description,
  icon,
  iconColor,
  reportStatus,
  reportType
}) => {
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [showYearPicker, setShowYearPicker] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  // Using lazy queries for on-demand fetching
  const [triggerIncomeReport] = useLazyGetAnnualIncomeReportQuery();
  const [triggerOccupancyReport] = useLazyGetAnnualOccupancyReportQuery();
  const [triggerExpenseReport] = useLazyGetAnnualExpenseReportQuery();
  const [triggerRepairsReport] = useLazyGetAnnualRepairsReportQuery();

const handleDownload = async (year) => {
    setIsDownloading(true);
    const toastId = toast.info('Preparing your report download...', {
        autoClose: false,
        closeButton: false
    });

    try {
        let response;
        const downloadParams = { year };

        switch(reportType) {
            case 'rent-income':
                response = await triggerIncomeReport(downloadParams).unwrap();
                break;
            case 'tenant-analytics':
                response = await triggerOccupancyReport(downloadParams).unwrap();
                break;
            case 'utilities-report':
                response = await triggerExpenseReport(downloadParams).unwrap();
                break;
            case 'maintenance-dashboard':
                response = await triggerRepairsReport(downloadParams).unwrap();
                break;
            default:
                throw new Error('Invalid report type');
        }

        // Create download link for the blob
        const url = window.URL.createObjectURL(response);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${reportType}-report-${year}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        toast.update(toastId, {
            render: 'Report downloaded successfully!',
            type: toast.TYPE.SUCCESS,
            autoClose: 3000
        });
    } catch (error) {
        toast.update(toastId, {
            render: error.message || 'Failed to download report',
            type: toast.TYPE.ERROR,
            autoClose: 5000
        });
    } finally {
        setIsDownloading(false);
        setShowYearPicker(false);
    }
};

  const handleYearSelect = () => {
    handleDownload(selectedYear);
  };

  // Extract the color from the iconColor prop to use for buttons
  const colorClass = iconColor.match(/bg-(.+)-[0-9]+/)[1];
  const buttonColor = `bg-${colorClass}-600 hover:bg-${colorClass}-700`;

  return (
    <div className="group bg-white hover:shadow-lg border border-gray-50 rounded-2xl overflow-hidden transition-all duration-300">
      <div className="p-6">
        <div className="flex items-start gap-4">
          {/* Icon container */}
          <div className={`p-2.5 rounded-lg ${iconColor} bg-opacity-15 flex-shrink-0`}>
            {React.cloneElement(icon, {
              className: `${icon.props.className} group-hover:scale-105 transition-transform w-4 h-4`
            })}
          </div>

          {/* Text content */}
          <div className="flex-1 space-y-3 min-w-0">
            {/* Title row */}
            <div className="flex justify-between items-start">
              <div className="flex items-center gap-2">
                <h3 className="font-semibold text-gray-800 text-lg leading-tight">
                  {title}
                </h3>
              </div>
            </div>

            {/* Description */}
            <p className="text-gray-500 text-sm line-clamp-2 leading-relaxed">
              {description}
            </p>

            {/* Footer with view stats */}
            <div className="flex justify-between items-center pt-2">
              <div className="flex items-center text-gray-400 text-xs">
                {reportStatus && (
                  <span className='text-uppercase'>{reportStatus}</span>
                )}
              </div>

              {reportStatus ? "" : (
                <div className="relative">
                  <button
                    onClick={() => setShowYearPicker(true)}
                    disabled={isDownloading}
                    className={`text-white px-3 py-1 rounded-lg text-sm font-medium ${buttonColor} transition-colors flex items-center gap-1`}
                  >
                    {isDownloading ? (
                      <Loader className="w-4 h-4 animate-spin" />
                    ) : (
                      'Get Report'
                    )}
                  </button>

                  {showYearPicker && (
                    <div className="right-0 bottom-full z-10 absolute bg-white shadow-lg mb-2 p-3 border border-gray-200 rounded-lg w-64">
                      <p className="mb-1 font-medium text-gray-700 text-sm">Select Year</p>
                      <select
                        value={selectedYear}
                        onChange={(e) => setSelectedYear(Number(e.target.value))}
                        className="mb-3 p-2 border border-gray-300 rounded w-full"
                        disabled={isDownloading}
                      >
                        {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i).map(year => (
                          <option key={year} value={year}>{year}</option>
                        ))}
                      </select>
                      <div className="flex gap-2">
                        <button
                          onClick={handleYearSelect}
                          disabled={isDownloading}
                          className={`flex-1 text-white px-3 py-1 rounded-lg text-sm font-medium ${buttonColor} transition-colors`}
                        >
                          {isDownloading ? (
                            <Loader className="mx-auto w-4 h-4 animate-spin" />
                          ) : (
                            'Download Report'
                          )}
                        </button>
                        <button
                          onClick={() => setShowYearPicker(false)}
                          disabled={isDownloading}
                          className="flex-1 bg-gray-200 hover:bg-gray-300 px-3 py-1 rounded-lg font-medium text-gray-700 text-sm transition-colors"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


const AvailableReports = () => {
  const [activeFilter, setActiveFilter] = useState('all');

  const allReports = [
    {
      id: 1,
      title: "Rent Income Collection Report",
      description: "Detailed breakdown of rent payments, delinquencies, and collection rates across all properties.",
      updatedTime: "Updated 2 hours ago",
      lastViewed: "today",
      views: "",
      isNew: true,
      category: "financial",
      icon: <DollarSign className="w-5 h-5 text-purple-600" />,
      iconColor: "bg-purple-100",
      reportType: "rent-income"
    },
    {
      id: 2,
      title: "Tenant Analytics",
      description: "Comprehensive tenant profiles, lease expirations, and satisfaction metrics.",
      updatedTime: "Updated yesterday",
      lastViewed: "2 days ago",
      views: "18",
      isNew: false,
      category: "tenant",
      icon: <Users className="w-5 h-5 text-blue-600" />,
      iconColor: "bg-blue-100",
      reportType: "tenant-analytics"
    },
    {
      id: 3,
      title: "Property Valuation",
      description: "Current market values, appreciation trends, and comparative analysis for your portfolio.",
      updatedTime: "Updated 1 day ago",
      lastViewed: "yesterday",
      views: "32",
      isNew: false,
      category: "financial",
      icon: <TrendingUp className="w-5 h-5 text-green-600" />,
      iconColor: "bg-green-100",
      reportStatus: "Coming Soon",
      reportType: "property-valuation"
    },
    {
      id: 4,
      title: "Maintenance Dashboard",
      description: "Open work orders, maintenance costs, and vendor performance metrics.",
      updatedTime: "Updated 5 hours ago",
      lastViewed: "today",
      views: "15",
      isNew: false,
      category: "maintenance",
      icon: <Wrench className="w-5 h-5 text-yellow-600" />,
      iconColor: "bg-yellow-100",
      reportType: "maintenance-dashboard"
    },
    {
      id: 5,
      title: "Utilities Report",
      description: "Utility costs, consumption trends, and financial performance across all properties.",
      updatedTime: "Updated 3 hours ago",
      lastViewed: "Today",
      views: "21",
      isNew: true,
      category: "financial",
      icon: <Zap className="w-5 h-5 text-pink-600" />,
      iconColor: "bg-pink-100",
      reportType: "utilities-report"
    },
    // {
    //   id: 6,
    //   title: "Expense Analysis",
    //   description: "Operating expenses, capital expenditures, and budget variance reporting.",
    //   updatedTime: "Updated 4 hours ago",
    //   lastViewed: "1 hour ago",
    //   views: "12",
    //   isNew: false,
    //   category: "financial",
    //   icon: <FileText className="w-5 h-5 text-yellow-800" />,
    //   iconColor: "bg-yellow-200",
    //   reportStatus: "Coming Soon",
    //   reportType: "expense-analysis"
    // },
    {
      id: 7,
      title: "Financial Performance",
      description: "NOI calculations, cash flow statements, and ROI metrics for your portfolio.",
      updatedTime: "Updated 6 hours ago",
      lastViewed: "today",
      views: "28",
      isNew: false,
      category: "financial",
      icon: <BarChart2 className="w-5 h-5 text-gray-600" />,
      iconColor: "bg-gray-300",
      reportStatus: "Coming Soon",
      reportType: "financial-performance"
    },
    {
      id: 8,
      title: "Vendor Management",
      description: "Contractor performance, service level agreements, and payment histories.",
      updatedTime: "Updated 1 week ago",
      lastViewed: "3 days ago",
      views: "9",
      isNew: false,
      category: "operational",
      icon: <Package className="w-5 h-5 text-red-600" />,
      iconColor: "bg-red-100",
      reportStatus: "Coming Soon",
      reportType: "vendor-management"
    }
  ];

  const filteredReports = activeFilter === 'all'
    ? allReports
    : allReports.filter(report => report.category === activeFilter);

  const filterButtons = [
    { id: 'all', label: 'All Reports' },
    { id: 'financial', label: 'Financial' },
    { id: 'operational', label: 'Operational' },
    { id: 'tenant', label: 'Tenant' },
    { id: 'maintenance', label: 'Maintenance' },
  ];

  return (
    <div className="bg-white shadow-lg p-6 rounded-xl">
      <div className="flex md:flex-row flex-col justify-between items-start md:items-center gap-4 mb-8">
        <div>
          <h1 className="font-bold text-gray-900 text-2xl md:text-3xl">Property Reports</h1>
        </div>

        <div className="flex sm:flex-row flex-col gap-3 w-full md:w-auto">
          <div className="relative flex-1 max-w-md">
            <Search className="top-1/2 left-3 absolute w-4 h-4 text-gray-400 -translate-y-1/2 transform" />
            <input
              type="text"
              placeholder="Search reports..."
              className="bg-white py-2.5 pr-4 pl-10 border border-gray-200 focus:border-blue-500 rounded-xl focus:ring-blue-500 w-full text-sm"
            />
          </div>
        </div>
      </div>

      <div className="flex flex-wrap gap-3 mb-6">
        {filterButtons.map((button) => (
          <button
            key={button.id}
            onClick={() => setActiveFilter(button.id)}
            className={`px-4 py-2 rounded-xl text-sm font-medium flex items-center transition-colors ${activeFilter === button.id
              ? 'bg-indigo-600 text-white shadow-md'
              : 'bg-white hover:bg-gray-50 border border-gray-200 text-gray-600'
              }`}
          >
            {button.icon || null}
            {button.label}
          </button>
        ))}
      </div>

      <div className="gap-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {filteredReports.map((report) => (
          <ReportCard
            key={report.id}
            title={report.title}
            description={report.description}
            updatedTime={report.updatedTime}
            lastViewed={report.lastViewed}
            views={report.views}
            isNew={report.isNew}
            icon={report.icon}
            iconColor={report.iconColor}
            reportStatus={report.reportStatus}
            reportType={report.reportType}
          />
        ))}
      </div>

      {filteredReports.length === 0 && (
        <>
          <div className="py-12 text-center">
            <div className="flex justify-center items-center bg-gray-100 mx-auto mb-4 rounded-full w-24 h-24">
              <FileText className="w-10 h-10 text-gray-400" />
            </div>
            <h3 className="mb-1 font-medium text-gray-900 text-lg">No reports found</h3>
            <p className="text-gray-500">Try adjusting your filters or search criteria</p>
          </div>

          <div className="flex justify-center mt-8">
            <button className="flex items-center gap-2 bg-white hover:bg-gray-50 px-5 py-2.5 border border-gray-200 rounded-xl font-medium text-gray-600 text-sm">
              Load More Reports
              <ChevronRight className="w-4 h-4" />
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default AvailableReports;